import * as React from 'react';

import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import {
  ProjectFileUpload,
  ProjectVirtualGraph,
} from 'src/store/state/projects';
import * as copy from 'src/templates/copy';

export const InvalidMappingsWarning: React.VFC<{
  fileUploadsById: Record<string, ProjectFileUpload>;
  labelsByIri: Record<string, string>;
  mappingsByResource: Record<
    string,
    Array<Mapping & { relationshipIri?: string }>
  >;
  virtualGraphsById: Record<string, ProjectVirtualGraph>;
}> = ({
  fileUploadsById,
  labelsByIri,
  mappingsByResource,
  virtualGraphsById,
}) => (
  <>
    <p>{copy.components.invalidMappings.dialog.message}</p>
    {Object.entries(mappingsByResource).map(([resourceId, mappings]) => (
      <div key={resourceId} className="sd-dialog-invalid-mappings__file">
        {fileUploadsById[resourceId]?.name ||
          virtualGraphsById[resourceId]?.name ||
          resourceId}
        <ul>
          {mappings.map((mapping) => (
            <li key={`${mapping.value}-${mapping.relationshipIri}`}>
              {mapping.text}
              {mapping.relationshipIri
                ? ` (${getLabelForIri(labelsByIri, mapping.relationshipIri)})`
                : ''}
            </li>
          ))}
        </ul>
      </div>
    ))}
  </>
);
